var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.1667 4.33333L9.23705 2.4741C8.9695 1.939 8.83572 1.67144 8.63614 1.47597C8.45965 1.30311 8.24694 1.17164 8.0134 1.09109C7.7493 1 7.45017 1 6.85191 1H3.66667C2.73325 1 2.26654 1 1.91002 1.18166C1.59641 1.34144 1.34144 1.59641 1.18166 1.91002C1 2.26654 1 2.73325 1 3.66667V4.33333M1 4.33333H13.6667C15.0668 4.33333 15.7669 4.33333 16.3016 4.60582C16.772 4.8455 17.1545 5.22795 17.3942 5.69836C17.6667 6.23314 17.6667 6.9332 17.6667 8.33333V12C17.6667 13.4001 17.6667 14.1002 17.3942 14.635C17.1545 15.1054 16.772 15.4878 16.3016 15.7275C15.7669 16 15.0668 16 13.6667 16H5C3.59987 16 2.8998 16 2.36502 15.7275C1.89462 15.4878 1.51217 15.1054 1.27248 14.635C1 14.1002 1 13.4001 1 12V4.33333Z",
    stroke: "var(--stroke-0, #9F9F9F)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1bc31e9c8b20cbfba58fafed71649490.svg";
export { ForwardRef as ReactComponent };